






























































import mixins from 'vue-typed-mixins';
import AuthUtils from '@/utils/AuthUtils';
export default mixins().extend({
  data(): {
    identity: string;
    password: string;
    confirmation: string;
  } {
    return {
      identity: '',
      password: '',
      confirmation: '',
    };
  },
  async mounted() {
    try {
      if (this.$route.query.language) {
        this.$i18n.locale = this.$route.query.language as string;
      }
    } catch (error) {
      (this.$refs.alert as any).show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
  methods: {
    async sendEmail() {
      try {
        (this.$refs.alert as any).hide('email');
        await AuthUtils.forgotPassword({
          identity: this.identity,
        });
        this.$toast.push({
          type: 'success',
          text: this.$languageobj('page.login.forgotPasswordEmailSent'),
        });
      } catch (error) {
        (this.$refs.alert as any).show('email', {
          type: 'error',
          messages: this.$handleAPIError(error, this.$refs.observer),
        });
      }
    },
    async reset() {
      let tokenValue = this.$route.query.token as string;
      try {
        (this.$refs.alert as any).hide('reset');
        AuthUtils.clear();
        await AuthUtils.changePassword({
          token: tokenValue,
          password: this.password,
        });
        try {
          await this.$router.push({ name: 'dashboard' });
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('page.login.resetPasswordSuccess'),
          });
        } catch (error) {
          // doesn't matter
        }
      } catch (error) {
        (this.$refs.alert as any).show('reset', {
          type: 'error',
          messages: this.$handleAPIError(error, this.$refs.observer),
        });
      }
    },
  },
});
